import { render, staticRenderFns } from "./PositionTemplate.vue?vue&type=template&id=e0c29a54&scoped=true&"
import script from "./PositionTemplate.vue?vue&type=script&lang=js&"
export * from "./PositionTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PositionTemplate.vue?vue&type=style&index=0&id=e0c29a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c29a54",
  null
  
)

export default component.exports